<template>
  <aside
    :class="[
      'fixed mt-16 flex flex-col lg:mt-022 top-0 left-0 bg-white border-semantic-secondary-default text-gray-900 h-full transition-all duration-300 ease-in-out z-[999] border-r-0',
      {
        'lg:w-[290px]': isExpanded || isMobileOpen || isHovered,
        'lg:w-[88px] shadow-lg': !isExpanded && !isHovered,
        'translate-x-0 w-[290px] shadow-lg': isMobileOpen,
        '-translate-x-full': !isMobileOpen,
        'lg:translate-x-0': true
      }
    ]"
    @mouseenter="!isExpanded && (isHovered = !true)"
    @mouseleave="isHovered = false"
  >
    <!-- <div
      :class="[
        'py-5 px-5 min-h-[4.3rem] flex hidden lg:flex2 bg-semantic-inverse-surface-light border-r border-semantic-secondary-default lg:border-b lg:pl-8',
        !isExpanded && !isHovered ? 'lg:justify-center' : 'justify-start'
      ]"
    >
      <NuxtLink to="/">
        <NuxtImg
          v-if="isExpanded || isHovered || isMobileOpen"
          src="/images/cc-logo-white-text.svg"
          alt="Logo"
          width="167"
          height="28"
          class="max-w-[9rem] xs:max-w-unset xs:min-w-[10.4375rem] lg:w-auto pl-4"
        />
        <template v-else>
          <NuxtImg
            src="images/cc-icon.svg"
            alt="Logo"
            width="25"
            height="28"
          />
        </template>
        
      </NuxtLink>
    </div> -->
    <div class="flex flex-col px-5 pt-5 overflow-y-auto duration-300 ease-linear no-scrollbar h-full border-r border-gray-300 mb-16">
      <nav class="mb-6">
        <div class="flex flex-col gap-4">
          <div v-for="(menuGroup, groupIndex) in menuGroups" :key="groupIndex">
            <h2
              :class=" [
                'mb-4 text-xs uppercase flex leading-[20px] text-gray-400',
                !isExpanded && !isHovered ? 'lg:justify-center' : 'justify-start'
              ]"
            >
              <template v-if="isExpanded || isHovered || isMobileOpen">
                {{ menuGroup.title }}
              </template>
              <IconsHorizontalDots v-else-if="groupIndex !== 0" />
            </h2>
            <ul class="flex flex-col gap-4">
              <li v-for="(item, index) in menuGroup.items" :key="item.name">
                <button
                  v-if="item.subItems"
                  :class=" [
                    'relative flex items-center w-full gap-3 px-3 py-2 font-medium rounded-lg text-sm group',
                    isSubmenuOpen(groupIndex, index)
                      ? 'bg-semantic-primary-default text-semantic-primary-on-default'
                      : 'text-gray-300 hover:bg-white/5 hover:text-gray-300',
                    !isExpanded && !isHovered ? 'lg:justify-center' : 'lg:justify-start'
                  ]"
                  @click="toggleSubmenu(groupIndex, index)"
                >
                  <span
                    :class=" [
                      isSubmenuOpen(groupIndex, index)
                        ? 'text-semantic-surface-on-surface'
                        : 'text-gray-400 group-hover:text-gray-300'
                    ]"
                  >
                    <component
                      :is="item.icon"
                      fill="currentColor"
                      width="24"
                      height="24" />
                  </span>
                  <span
                    v-if="isExpanded || isHovered || isMobileOpen"
                    class="inline"
                  >{{ item.name }}</span>
                  <IconsChevronDown
                    v-if="isExpanded || isHovered || isMobileOpen"
                    :class=" [
                      'ml-auto w-5 h-5 transition-transform duration-200',
                      isSubmenuOpen(groupIndex, index) ? 'rotate-180 text-semantic-primary-on-default' : ''
                    ]"
                  />
                </button>
                <NuxtLink
                  v-else-if="item.path"
                  :to="item.path"
                  :class=" [
                    'relative flex items-center w-full gap-3 px-3 py-2 font-medium rounded-lg text-sm group',
                    isActive(item.path)
                      ? 'bg-semantic-surface-container-low text-semantic-primary-variant-dark'
                      : 'text-semantic-primary-variant-dark group-hover:text-semantic-primary-variant-dark hover:bg-semantic-surface-container-low hover:text-semantic-primary-on-dark',
                    !isExpanded && !isHovered ? 'lg:justify-center' : 'lg:justify-start'
                  ]"
                >
                  <span
                    :class=" [
                      isActive(item.path)
                        ? 'text-semantic-primary-variant-dark'
                        : 'text-semantic-primary-variant-dark group-hover:text-semantic-primary-on-dark'
                    ]"
                  >
                    <component
                      :is="item.icon"
                      fill="currentColor"
                      width="24"
                      height="24" />
                  </span>
                  <span
                    v-if="isExpanded || isHovered || isMobileOpen"
                    class="inline"
                  >{{ item.name }}</span>
                </NuxtLink>
                <transition
                  @enter="startTransition"
                  @after-enter="endTransition"
                  @before-leave="startTransition"
                  @after-leave="endTransition"
                >
                  <div
                    v-show="
                      isSubmenuOpen(groupIndex, index) &&
                        (isExpanded || isHovered || isMobileOpen)
                    "
                  >
                    <ul class="mt-2 space-y-1 ml-9">
                      <li v-for="subItem in item.subItems" :key="subItem.name">
                        <NuxtLink
                          :to="subItem.path"
                          :class=" [
                            'relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium',
                            isActive(subItem.path)
                              ? 'bg-brand-500/[0.12] text-brand-400'
                              : 'text-gray-300 hover:bg-white/5'
                          ]"
                        >
                          {{ subItem.name }}
                          <span class="flex items-center gap-1 ml-auto">
                            <span
                              v-if="subItem.new"
                              :class=" [
                                'block rounded-full px-2.5 py-0.5 text-xs font-medium uppercase text-semantic-surface-on-surface',
                                isActive(subItem.path)
                                  ? 'bg-brand-500/20'
                                  : 'bg-brand-500/15 group-hover:bg-brand-500/20'
                              ]"
                            >
                              new
                            </span>
                            <span
                              v-if="subItem.pro"
                              :class=" [
                                'block rounded-full px-2.5 py-0.5 text-xs font-medium uppercase text-semantic-surface-on-surface',
                                isActive(subItem.path)
                                  ? 'bg-brand-500/20'
                                  : 'bg-brand-500/15 group-hover:bg-brand-500/20'
                              ]"
                            >
                              pro
                            </span>
                          </span>
                        </NuxtLink>
                      </li>
                    </ul>
                  </div>
                </transition>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <Transition name="slide-fade">
        <OrganismsDashboardSidebarWidget v-if="isExpanded || isHovered || isMobileOpen" />
      </Transition>
    </div>
  </aside>
</template>

<script setup>
const route = useRoute()
const { isExpanded, isMobileOpen, isHovered, openSubmenu } = useSidebar()

const menuGroups = [
  {
    title: '',
    items: [
      {
        icon: resolveComponent('V2IconsHome'),
        name: 'Dashboard',
        // subItems: [{ name: 'Energy Dashboard', path: '/dashboard/energy', pro: false }]
        path: '/dashboard'
      },
      {
        icon: resolveComponent('V2IconsClipboard'),
        name: 'Quotes',
        path: '/dashboard/quotes'
      },
      {
        icon: resolveComponent('V2IconsPartyPopper'),
        name: 'Perks',
        path: '/dashboard/perks'
      },
      {
        icon: resolveComponent('V2IconsGift'),
        name: 'Gift Cards',
        path: '/dashboard/rewards'
      }
    ]
  }
]

const normalizePath = p => p.replace(/\/+$/, '')
const isActive = path => normalizePath(route.path) === normalizePath(path)

const toggleSubmenu = (groupIndex, itemIndex) => {
  const key = `${groupIndex}-${itemIndex}`
  openSubmenu.value = openSubmenu.value === key ? null : key
}

const isAnySubmenuRouteActive = computed(() => {
  return menuGroups.some(group =>
    group.items.some(
      item =>
        item.subItems && item.subItems.some(subItem => isActive(subItem.path))
    )
  )
})

const isSubmenuOpen = (groupIndex, itemIndex) => {
  const key = `${groupIndex}-${itemIndex}`
  return (
    openSubmenu.value === key ||
    (isAnySubmenuRouteActive.value &&
      menuGroups[groupIndex].items[itemIndex].subItems?.some(subItem =>
        isActive(subItem.path)
      ))
  )
}

const startTransition = el => {
  el.style.height = 'auto'
  const height = el.scrollHeight
  el.style.height = '0px'
  // force reflow
  void el.offsetHeight
  el.style.height = height + 'px'
}

const endTransition = el => {
  el.style.height = ''
}
</script>

<style scoped>
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
::v-deep(.no-scrollbar::-webkit-scrollbar) {
  display: none;
}
.slide-fade-enter-active {
  transition: all 0.25s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
</style>
